import { UntypedFormGroup } from '@angular/forms';
import { BaseRepository } from '../../interfaces/base-repository';
import { BaseClass } from '../base-class';

export class ParametersOffer {
  parameterKey?: number;
  label: string;
  type: string;
  values: ValueParameter[] | string;
  isRequired: boolean;

  constructor(label: string, type: string, values: ValueParameter[] | string, isRequired: boolean) {
    this.label = label;
    this.type = type;
    this.values = values;
    this.isRequired = isRequired;
  }
}

export class ValueParameter {
  name: string;
  value: string;

  constructor(name: string, value: string) {
    this.name = name;
    this.value = value;
  }
}

export class InputParamsOffer {
  label: string;
  type: string;
  values: string[];
  isRequired: boolean;
  input: UntypedFormGroup;
}

export class Parameter extends BaseClass implements BaseRepository {
  parameterKey?: number;
  label: string;
  type: string;
  values: ValueParameter[] | string;
  isFirstPage?: boolean;
  selectedValue?: string;
  isDefault?: boolean;

  constructor()
  constructor(
    label: string,
    type: string,
    values: ValueParameter[] | string
  )
  constructor(label?: string, type?: string, values?: ValueParameter[] | string) {
    super();
    this.label = label;
    this.type = type;
    this.values = values;
  }

  static fromObject(object: Parameter): Parameter {
    return Object.assign(new Parameter(), {
      ...object
    });
  }

  get display(): string {
    return this.label;
  }

  doesInclude(value: string): boolean {
    return this.some([this.label], value);
  }
}


export class InputParamTrainee {
  label: string;
  type: string;
  values: string[];
  input: UntypedFormGroup;
  parameterKey?: number;
  isDefault: boolean;
}
